import { ContentType } from "./http-client";

export class StampTax {
  constructor(http) {
    this.http = http;
  }

  calculate = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  save = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  get = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  uploadProof = (rentalId, taxId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/stamp-tax/${taxId}/upload-proof`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
